module.exports = __webpack_public_path__ + "img/logo.e8a2728a.png";